import { Stack } from '@mui/material';

import { Text } from '../Text';
import cls from './CardTemplste.module.scss';

interface MedOrgInfoCardProps {
  title: string;
  children: React.ReactNode;
}

export const CardTemplate = (props: MedOrgInfoCardProps) => {
  const { title, children } = props;

  return (
    <Stack className={cls.CardWrapper}>
      <Text variant='h6'>{title}</Text>
      {children}
    </Stack>
  );
};
